<template>
  <v-container id="evidence-list">
    <city-header :payload="city"> </city-header>

    <v-row v-if="tabsChoosed !== 5">
      <v-col v-if="isSala">Critérios</v-col>
      <v-col v-else>Perguntas</v-col>
      <v-col class="text-right" v-if="!isSala">
        <v-btn
          v-if="
            isAdmin ||
            isConsultorCondutorMunicipio ||
            isConsultorEspecialistaMunicipio ||
            isADMunicipio
          "
          outlined
          color="primary"
          class="ml-3"
          @click="loadQuestions"
        >
          <span>Download PDF Perguntas</span>
        </v-btn>
      </v-col>
    </v-row>
    <div v-if="tabsChoosed === 5 && isSala" class="vindas mt-5">
      <BoasVindas></BoasVindas>
      <v-btn
        color="laranja"
        style="margin: auto; color: #fff"
        :to="'/cidade/' + payload.municipioId + '/evidencia/respondida'"
        @click="tabsChoosed = 1"
      >
        Eu concordo
      </v-btn>
    </div>

    <v-row v-if="tabsChoosed !== 5">
      <v-col>
        <v-bottom-navigation :value="activeBtn" color="primary">
          <v-divider vertical v-if="isSala"></v-divider>
          <v-btn
            :to="'/cidade/' + payload.municipioId + '/evidencia/boasvindas'"
            @click="tabsChoosed = 5"
            v-if="isSala"
          >
            Boas Vindas
          </v-btn>

          <v-divider vertical></v-divider>

          <v-btn
            :to="'/cidade/' + payload.municipioId + '/evidencia/respondida'"
            @click="tabsChoosed = 1"
          >
            <span v-if="isSala">Não enviados</span>
            <span v-else>Respondidas</span>
          </v-btn>
          <v-divider vertical></v-divider>

          <v-btn
            :to="'/cidade/' + payload.municipioId + '/evidencia/evidenciada'"
            @click="tabsChoosed = 2"
          >
            <span v-if="isSala">Em análise</span>
            <span v-else>Evidenciadas em Análise</span>
          </v-btn>
          <v-divider vertical></v-divider>

          <v-btn
            :to="'/cidade/' + payload.municipioId + '/evidencia/aprovada'"
            @click="tabsChoosed = 3"
          >
            <span v-if="isSala">Aprovados</span>
            <span v-else>Aprovadas</span>
          </v-btn>
          <v-divider vertical></v-divider>

          <v-btn
            :to="'/cidade/' + payload.municipioId + '/evidencia/rejeitada'"
            @click="tabsChoosed = 4"
            style="padding: 0 10px !important"
          >
            <span v-if="isSala">Com evidências rejeitadas</span>
            <span v-else>Rejeitadas</span>
          </v-btn>

          <v-divider vertical></v-divider>
        </v-bottom-navigation>
      </v-col>
    </v-row>
    <v-row v-if="tabsChoosed != 5">
      <v-col>
        <app-tema-combobox
          @onChange="changeTemaIds"
          :name="isSala ? 'Pilares' : 'Temas'"
        ></app-tema-combobox>
      </v-col>
      <v-col cols="1">
        <v-btn color="primary"> Filtrar </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <app-evidence-respondida
          v-if="tabsChoosed === 1"
          :filter="filter"
          :visualizarPontosMedalha="visualizarPontosMedalha()"
        ></app-evidence-respondida>
        <app-evidence-evidenciada
          v-if="tabsChoosed === 2"
          :filter="filter"
          :visualizarPontosMedalha="visualizarPontosMedalha()"
        ></app-evidence-evidenciada>
        <app-evidence-aprovadas
          v-if="tabsChoosed === 3"
          :filter="filter"
          :visualizarPontosMedalha="visualizarPontosMedalha()"
        ></app-evidence-aprovadas>
        <app-evidence-rejeitadas
          v-if="tabsChoosed === 4"
          :filter="filter"
          :visualizarPontosMedalha="visualizarPontosMedalha()"
        ></app-evidence-rejeitadas>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CityHeader from "../Header";
import { cityAPI, cityQuestionAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import AppEvidenceRespondida from "./Respondidas";
import AppEvidenceEvidenciada from "./Evidenciada";
import AppEvidenceAprovadas from "./Aprovadas";
import AppEvidenceRejeitadas from "./Rejeitadas";
import AppTemaCombobox from "@/modules/tema/components/TemaCombobox";
import {
  statusRelacionamentoEnum,
  statusRelacionamentoSeloEnum,
  statusContratoEnum,
} from "@/types";
import BoasVindas from "./selo/BoasVindas.vue";

export default {
  components: {
    CityHeader,
    AppEvidenceRespondida,
    AppEvidenceEvidenciada,
    AppEvidenceAprovadas,
    AppEvidenceRejeitadas,
    AppTemaCombobox,
    BoasVindas,
  },
  watch: {
    loading(val) {
      if (this.removeLoadingFirst) this.setLoading(val);
      else this.setLoading(true);
    },
  },
  data() {
    return {
      headers: [
        { text: "Tema", value: "pergunta.tema.nome" },
        { text: "Número", value: "pergunta.numero" },
        { text: "Texto", value: "pergunta.texto" },
        { text: "Pontos", value: "pergunta.pontos" },
        { text: "", value: "enviar" },
        { text: "", value: "acao" },
        { text: "Evidência", value: "pergunta.evidencia" },
      ],
      expanded: [],
      payload: {
        municipioId: this.$route.params.id,
        perguntas: [],
      },
      tabsValue: {
        boasvindas: 5,
        respondida: 1,
        evidenciada: 2,
        aprovada: 3,
        rejeitada: 4,
      },
      tabsChoosed: 1,
      activeBtn: 0,
      perguntas: [],
      city: {},
      filter: {
        municipioId: this.$route.params.id,
        temas: [],
      },
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      user: JSON.parse(localStorage.getItem("user")),
      statusContratoEnum: statusContratoEnum,
      statusRelacionamentoEnum: statusRelacionamentoEnum,
      statusRelacionamentoSeloEnum: statusRelacionamentoSeloEnum,
      removeLoadingFirst: false,
    };
  },
  methods: {
    ...mapActions([
      "setLoading",
      "setConsultorCondutorMunicipio",
      "setConsultorEspecialistaMunicipio",
      "setAnalistaMunicipio",
      "setADMunicipio",
      "setCityName",
      "setCityId",
    ]),
    changeTemaIds(e) {
      this.filter.temas = e;
    },

    updateQuestion(e) {
      this.payload.perguntas = this.payload.perguntas.map((item) => {
        if (item.perguntaMunicipioId === e.perguntaMunicipioId) {
          return {
            ...item,
            ...e,
          };
        }
        return item;
      });
    },

    loadQuestions() {
      this.setLoading(true);
      cityQuestionAPI
        .getPerguntas(this.$route.params.id)
        .then((resp) => {
          this.perguntas = resp.data;
          this.setLoading(false);
          this.createPDF();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter perguntas");
        });
    },
    createPDF() {
      this.setLoading(true);
      cityQuestionAPI
        .getPDFPerguntas(this.filter)
        .then((resp) => {
          let blob = new Blob([resp.data], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Perguntas - " + this.filter.nome + ".pdf";
          link.click();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter PDF de perguntas");
        });
    },
    loadCity() {
      cityAPI
        .get(this.$route.params.id)
        .then((resp) => {
          this.city = resp.data;
          this.setCityName(this.city.nome);
          this.setCityId(this.city.municipioId);
          this.filter.nome = this.city.nome;
          this.$forceUpdate();

          setTimeout(() => {
            this.removeLoadingFirst = true;
            this.setLoading(false);
          }, 1000);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter município");
        });
    },
    visualizarPontosMedalha() {
      if (
        this.isFullAdmin ||
        (this.config.visualizarPontosMedalha &&
          this.groupsConfig.visualizarPontosMedalha &&
          this.getMunicipioVigente())
      ) {
        return true;
      } else {
        return false;
      }
    },
    getMunicipioVigente() {
      let isVigente = true;
      if (this.city) {
        if (this.$store.state.uf === "RJ") {
          isVigente =
            this.statusContratoEnum.cidadeEmpreendedora ===
              this.city.statusContratoId &&
            !this.isSala &&
            !this.isAT &&
            this.city.statusId === this.statusRelacionamentoEnum.vigente;
        } else {
          isVigente =
            (this.isSala &&
              this.city.statusId ===
                this.statusRelacionamentoSeloEnum.participante) ||
            this.city.statusId === this.statusRelacionamentoEnum.vigente;
        }
      }

      return isVigente;
    },
  },
  mounted() {
    this.tabsChoosed = this.tabsValue[this.$route.params.tipoEvidencia];
    this.loadCity();
    this.setConsultorCondutorMunicipio(this.$route.params.id);
    this.setConsultorEspecialistaMunicipio(this.$route.params.id);
    this.setAnalistaMunicipio(this.$route.params.id);
    this.setADMunicipio(this.$route.params.id);
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "uf",
      "isSala",
      "logo",
      "isFullAdmin",
      "loading",
    ]),
  },
};
</script>
<style>
.v-item-group.v-bottom-navigation .v-btn {
  max-width: 200px;
}
</style>

<style lang="scss">
.vindas {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
a {
  text-decoration: none;
}
.p-0 {
  padding: 0 !important;
}
.hasEvidence {
  background: url("/assets/img/certo1.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
}
.hasNoEvidence {
  background: url("/assets/img/noEvidence.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
}
.semStatus {
  background: url("/assets/img/search.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
}

.optionsExpanded {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.openExpanded {
  background: url("/assets/img/right-arrow.png") no-repeat;
  width: 20px;
  height: 20px;
  transform: rotate(90deg);
  display: block;
  background-size: contain;
  /* text-align: center; */
  margin: 0 auto;
  float: right;
}
.expandedClass {
  transform: rotate(270deg);
}
</style>
